module.exports = __webpack_public_path__ + "static/page-banner-data-analytics-72ffb15792eb741957a339a42ef899b6.png";